import classNames from 'classnames'

export default function NameIcon({
  fullName,
  heightClassName = `h-12`,
  widthClassName = `w-12`,
  backgroundClassName = `bg-blue-100`,
  borderClassName = ``,
  textClassName = `text-blue-600 font-bold`,
  sizeStyle = {},
  isTiny = false,
}: {
  fullName?: string
  heightClassName?: string
  widthClassName?: string
  backgroundClassName?: string
  borderClassName?: string
  textClassName?: string
  sizeStyle?: Record<string, string | number>
  isTiny?: boolean
}) {
  return (
    <div
      className={classNames(
        `flex shrink-0 items-center justify-center rounded-md align-middle text-ui-sm capitalize`,
        backgroundClassName,
        heightClassName,
        widthClassName,
        borderClassName,
      )}
      style={isTiny ? { fontSize: `10px` } : sizeStyle}
    >
      <p className={textClassName}>{fullName}</p>
    </div>
  )
}
